import { NotificationService } from '../notification/swal/notification.service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/finally';

@Injectable()
export class AppServiceInterceptor implements HttpInterceptor {

  constructor(private notificationService: NotificationService, private router: Router) { }

  private handleHttpError(err: HttpErrorResponse) {
    if (err.status === 401 && err.url.split('/').slice(-1).pop() !== 'token') {
      this.notificationService.showAlertNotification('Sua sessão expirou!', { allowOutsideClick: false, showCancelButton: false });
      localStorage.clear();
      this.router.navigate(['/login']);
    }
  }

  formatExceptions(ex: HttpErrorResponse) {
    if (ex.status >= 500) {
      return {
        message: 'Ocorreu um erro inesperado, por favor entre em contato.'
      };
    } else {
      if (ex.error && ex.error.errors && ex.error.errors[0] &&  ex.error.errors[0].messages[0]) {
        return {
          message: ex.error.errors[0].messages[0]
        };
      } else if (ex.error && ex.error.message) {
        return {
          message: ex.error.message
        };
      } else if (ex.error && ex.error.error_description) {
        return {
          message: ex.error.error_description
        };
      } else if (ex.error) {
        return {
          message: ex.error
        };
      } else {
        return {
          message: 'Ocorreu um erro inesperado, por favor entre em contato.'
        };
      }
    }
  }

  createConnectionException() {
    return {
      message: 'Sem conexão com a internet!'
    };
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.split('Extrato').length === 1) {
      this.notificationService.openLoading({
        customClass: 'httpRequestLoading',
        grow: 'fullscreen'
      });
    }
    if (navigator.onLine) {
      return next.handle(req)
        .catch((err: HttpErrorResponse) => {
          this.handleHttpError(err);
          return Observable.throw(this.formatExceptions(err));
        })
        .finally(() => {
          this.notificationService.closeLoading();
        });
    } else {
      this.notificationService.closeLoading();
      return Observable.throw(this.createConnectionException());
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/interceptors/app.service.interceptor.ts